<div class="table-wrapper" *ngIf="data?.length != 0">
 <table mat-table [dataSource]="data" class="mat-elevation-z8" cdkDropList (cdkDropListDropped)="handleDrop($event)">
    <!-- Dynamic Columns -->
<ng-container *ngFor="let column of columns" [matColumnDef]="column">
  <ng-container *ngIf="column === 'dragdrop'">
    <th mat-header-cell *matHeaderCellDef>Drag</th>
    <td mat-cell *matCellDef="let element">
      <img
        cdkDragHandle
        src="assets/images/drag-icon.svg"
        alt="Drag handle"
        class="drag-icon">
    </td>
  </ng-container>
      <!-- Checkbox Column -->
      <ng-container *ngIf="column === 'checkbox'">
        <th mat-header-cell *matHeaderCellDef class="checkbox">
          <mat-checkbox
            (change)="toggleAllRows($event)"
            [checked]="isAllSelected()"
            [indeterminate]="isSomeSelected()"
            [disabled]="data.length === 0"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            (change)="toggleRow(element)"
            [checked]="isRowSelected(element)"
            [disabled]="data.length === 0"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container *ngIf="column === 'active_status'">
                <th mat-header-cell *matHeaderCellDef class="active_status">
           <!-- {{ column | removeUnderscore }} -->
             <span *ngIf="column === 'active_status'">Status</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle class="status"
            (change)="updateToggleStatus(element, $event)"
            [checked]="element.status === 1"
            [disabled]="data.length === 0"></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container *ngIf="column !== 'dragdrop' && column !== 'checkbox' && column !== 'active_status'">
        <th mat-header-cell *matHeaderCellDef>
          {{ column | removeUnderscore }}
              <!-- ✅ Sorting only for allowed columns -->
    <ng-container *ngIf="isSorting && !['checkbox', 'log', 'action', 'status', 's_no', 'assignment','icon', 'year'].includes(column?.toLowerCase())">
      <app-gis-data-table-sorting
        [sortField]="column"
        [activeField]="sortField"
        [sortOrder]="sortOrder"
        (sortEvent)="onSort($event)">
      </app-gis-data-table-sorting>
    </ng-container>

        </th>
      </ng-container>

      <td mat-cell *matCellDef="let element">
        <!-- Log Buttons -->
        <ng-container *ngIf="column === 'log'">
          <div class="button-wrapper">
            <button
              *ngFor="let button of buttons.log"
              (click)="button.action(element)"
              [ngStyle]="button.style"
              [ngClass]="button.class"
              [disabled]="button.label === 'Accept Log' && (element.status !== 2 && element.status !== -3 && element.status !== 4)"
            >
              {{ button.label }}
            </button>
          </div>
        </ng-container>

        <!-- Action Buttons -->
        <ng-container *ngIf="column === 'action'">
          <div class="button-wrapper">
            <ng-container *ngFor="let button of buttons.action">
              <button
                *ngIf="button.label !== 'Stop Process' || element.status === 3"
                class="action-btn "
                (click)="button.action(element)"
                [ngStyle]="button.style"
                [disabled]="isButtonDisabled(element, button.label)"
                [ngClass]="button.isActionColumnClass"
              >
               {{ button.label }}
                <img
                  [ngStyle]="button.style"
                  *ngIf="button.icon"
                  [src]="button.icon"
                  alt="delete"
                />

              </button>
            </ng-container>
          </div>
        </ng-container>

        <!-- query Buttons -->
        <ng-container *ngIf="column === 'query'">
          <div class="button-wrapper">
            <ng-container *ngFor="let button of buttons.query">
              <button
                class="action-btn"
                (click)="button.action(element)"
                [ngStyle]="button.style"
                [disabled]="isButtonDisabled(element, button.label)"
              >
                {{ button.label }}
                <img
                  [ngStyle]="button.style"
                  *ngIf="button.icon"
                  [src]="button.icon"
                  alt="delete"
                />
              </button>
            </ng-container>
          </div>
        </ng-container>

        <!-- conflict Buttons -->
        <ng-container *ngIf="column === 'conflict' || column === 'attributes'">
          <div class="button-wrapper">
            <ng-container *ngFor="let button of buttons.conflict">
              <button
                class="action-btn"
                (click)="button.action(element)"
                [ngStyle]="button.style"
                [disabled]="isButtonDisabled(element, button.label) || (!element?.data?.cities?.length && column === 'attributes')"
              >
                {{ button.label }}
                <img
                  [ngStyle]="button.style"
                  *ngIf="button.icon"
                  [src]="button.icon"
                  alt="delete"
                />
              </button>
            </ng-container>
          </div>
        </ng-container>

        <!-- Status Display -->
        <ng-container *ngIf="column === 'status'">
          <span
            [ngStyle]="{
              color: getStatusClass(element.status).color,
              'white-space': 'nowrap'
            }"
          >
            {{ getStatusClass(element.status).class }}
          </span>
        </ng-container>
          <!-- <ng-container *ngIf="column !== 'checkbox'">
        <th mat-header-cell *matHeaderCellDef class="sticky-header">
          <span>{{ column | removeUnderscore }}</span>
          <ng-container *ngIf="isSorting && !['checkbox', 'log', 'action', 'status', 's_no', 'assignment', 'year'].includes(column)">
            <app-gis-data-table-sorting
              [sortField]="column"
              [activeField]="sortField"
              [sortOrder]="sortOrder"
              (sortEvent)="onSort($event)">
            </app-gis-data-table-sorting>
          </ng-container>
        </th>

      </ng-container> -->

        <!-- Default Data Display -->
        <ng-container
          *ngIf="
            column !== 'log' &&
            column !== 'action' &&
            column !== 'status' &&
            column !== 'query' &&
            column !== 'conflict' &&
            column !== 'attributes'
          "
        >
          <div
            matTooltip="{{ formatValue(element[column]) }}"
            matTooltipDisabled="{{ !isTooltipNeeded(element[column]) }}"
          >
            {{ formatDisplayValue(element[column]) }}
          </div>
        </ng-container>
      </td>
    </ng-container>
     <!-- Add cdkDropList directive to the table -->
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row
        *matRowDef="let row; columns: columns;"
        [cdkDrag]="enableDragDrop ? true : null"
        [cdkDragDisabled]="!enableDragDrop"
        [cdkDragData]="row">
    </tr>
  </table>
</div>
<div *ngIf="totalCount && totalCount > 0" class="pagination-wrapper">
  <mat-paginator
    [length]="totalCount"
    showFirstLastButtons
    [pageSizeOptions]="pageSizeOptions"
    (page)="pageAction($event)"
  >
  </mat-paginator>
</div>
<div class="no-data" *ngIf="data?.length == 0">
  <div><img src="../../../../../assets/icon/no-data-found.svg" alt="" /></div>
  <p>No Records Found</p>
</div>
